module.exports = __webpack_public_path__ + "img/violet_118.312c90a6.png";